// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import { saveAs } from 'file-saver';
// import { format } from 'date-fns';
// import Select from 'react-select';

// const LedgerStatement = () => {
//     const [data, setData] = useState(null);
//     const [loading, setLoading] = useState(false);
//     const [error, setError] = useState(null);
//     const [projects, setProjects] = useState([]);
//     const [ledgers, setLedgers] = useState([]);
//     const [filters, setFilters] = useState({
//         start_date: '',
//         end_date: '',
//         ledger_id: '',
//         project_id: '',
//         reference_no: ''
//     });
//     const [selectedTransaction, setSelectedTransaction] = useState(null);
//     const [showModal, setShowModal] = useState(false);

//     const API_BASE_URL = process.env.REACT_APP_WEBZASH_URL || 'http://localhost/webzash-integration';
//     const API_KEY = process.env.REACT_APP_API_KEY || 'your_api_key_here';
//     const API_ORIGIN = process.env.REACT_APP_BACKEND_URL;

//     // Fetch projects and ledgers on component mount
//     useEffect(() => {
//         const fetchInitialData = async () => {
//             try {
//                 // Fetch projects
//                 const userInfo = JSON.parse(localStorage.getItem("user-info"));
//                 const origin = localStorage.getItem('user-origin');
//                 const token = userInfo?.token;

//                 const projectsResponse = await axios.get(`${API_ORIGIN}/api/projects`, {
//                     headers: {
//                         Authorization: `Bearer ${token}`,
//                         'Tenant-Origin': origin,
//                     }
//                 });

//                 setProjects(projectsResponse.data?.Data?.map(project => ({
//                     value: project.id,
//                     label: project.name
//                 })));

//                 // Fetch ledgers
//                 const ledgersResponse = await axios.get(`${API_BASE_URL}/api/ledgers/index`, {
//                     headers: {
//                         'x-api-key': API_KEY,
//                         'Accept': 'application/json',
//                     }
//                 });

//                 const grouped = ledgersResponse.data.data.reduce((acc, item) => {
//                     const groupName = item.Group?.name || 'Ungrouped';
//                     if (!acc[groupName]) {
//                         acc[groupName] = [];
//                     }
//                     acc[groupName].push({
//                         value: item.Ledger.id,
//                         label: item.Ledger.name,
//                     });
//                     return acc;
//                 }, {});

//                 const groupedOptions = Object.entries(grouped).map(([label, options]) => ({
//                     label,
//                     options
//                 }));

//                 setLedgers(groupedOptions);

//             } catch (err) {
//                 setError('Failed to load initial data');
//                 console.error('Initial data error:', err);
//             }
//         };

//         fetchInitialData();
//     }, [API_BASE_URL, API_KEY, API_ORIGIN]);

//     const fetchLedgerStatement = async () => {
//         setLoading(true);
//         setError(null);

//         try {
//             const params = new URLSearchParams();
//             if (filters.start_date) params.append('startdate', filters.start_date);
//             if (filters.end_date) params.append('enddate', filters.end_date);
//             if (filters.ledger_id) params.append('ledger_id', filters.ledger_id);
//             if (filters.project_id) params.append('project_id', filters.project_id);
//             if (filters.reference_no) params.append('reference_no', filters.reference_no);

//             // Only make the request if we have at least one filter
//             if (filters.start_date || filters.end_date || filters.ledger_id || filters.project_id || filters.reference_no) {
//                 const response = await axios.get(
//                     `${API_BASE_URL}/api/reports/ledgerstatement`,
//                     {
//                         headers: {
//                             'x-api-key': API_KEY,
//                             'Accept': 'application/json',
//                         },
//                         params
//                     }
//                 );
//                 setData(response.data);
//             } else {
//                 setError('Please select at least one filter criteria');
//             }
//         } catch (err) {
//             setError(err.response?.data?.message || 'Failed to fetch ledger statement');
//             console.error('API Error:', err);
//         } finally {
//             setLoading(false);
//         }
//     };

//     const handleSubmit = (e) => {
//         e.preventDefault();
//         fetchLedgerStatement();
//     };

//     const handleClear = () => {
//         setFilters({
//             start_date: '',
//             end_date: '',
//             ledger_id: '',
//             project_id: '',
//             reference_no: ''
//         });
//         setData(null);
//     };

//     const handleExport = async (formatType) => {
//         try {
//             const params = new URLSearchParams();
//             if (filters.start_date) params.append('startdate', filters.start_date);
//             if (filters.end_date) params.append('enddate', filters.end_date);
//             if (filters.ledger_id) params.append('ledger_id', filters.ledger_id);
//             if (filters.project_id) params.append('project_id', filters.project_id);
//             if (filters.reference_no) params.append('reference_no', filters.reference_no);
//             params.append('format', formatType);

//             const response = await axios.get(
//                 `${API_BASE_URL}/api/reports/ledgerstatement`,
//                 {
//                     headers: {
//                         'x-api-key': API_KEY,
//                         'Accept': 'application/octet-stream'
//                     },
//                     params,
//                     responseType: 'blob'
//                 }
//             );
//             const blob = new Blob([response.data], { type: response.headers['content-type'] });

//             const extension = formatType === 'csv' ? 'csv' : 'xls';
//             saveAs(blob, `ledger_statement_${filters.ledger_id || 'all'}_${filters.start_date || 'start'}_to_${filters.end_date || 'end'}.${extension}`);
//         } catch (err) {
//             setError(`Failed to export ${formatType.toUpperCase()}`);
//             console.error('Export Error:', err);
//         }
//     };

//     const printReport = () => {
//         window.open(
//             `${API_BASE_URL}/api/reports/ledgerstatement?format=print${filters.start_date ? `&startdate=${filters.start_date}` : ''}${filters.end_date ? `&enddate=${filters.end_date}` : ''}${filters.ledger_id ? `&ledger_id=${filters.ledger_id}` : ''}${filters.project_id ? `&project_id=${filters.project_id}` : ''}`,
//             '_blank'
//         );
//     };

//     // Calculate running balance
//     const calculateRunningBalance = (entries, openingBalance) => {
//         let balance = parseFloat(openingBalance?.amount || 0);
//         if (openingBalance?.dc === 'C') balance = -balance;

//         return entries.map(entry => {
//             const amount = parseFloat(entry.Entryitem.amount || 0);
//             if (entry.Entryitem.dc === 'D') {
//                 balance += amount;
//             } else {
//                 balance -= amount;
//             }
//             return {
//                 ...entry,
//                 runningBalance: balance
//             };
//         });
//     };

//     const entriesWithBalance = data?.entries ? calculateRunningBalance(data.entries, data.opening_balance) : [];


//     return (
//         <div className="main-content" style={{ backgroundColor: '#f8f9fa' }}>
//             <div className="page-content">
//                 <div className="container-fluid">
//                     <div className="row">
//                         <div className="col-12">
//                             <div className="page-title-box d-flex align-items-center justify-content-between">
//                                 <div>
//                                     <h4 className="mb-0 text-primary">Ledger Statement</h4>
//                                     <ol className="breadcrumb">
//                                         <li className="breadcrumb-item"><a href="#">Reports</a></li>
//                                         <li className="breadcrumb-item active">Ledger Statement</li>
//                                     </ol>
//                                 </div>
//                                 <div className="d-flex gap-2">
//                                     <button
//                                         onClick={() => handleExport('csv')}
//                                         className="btn btn-outline-primary btn-sm"
//                                         disabled={loading || !data}
//                                     >
//                                         <i className="fas fa-file-csv me-1"></i> CSV
//                                     </button>
//                                     <button
//                                         onClick={() => handleExport('xls')}
//                                         className="btn btn-outline-success btn-sm"
//                                         disabled={loading || !data}
//                                     >
//                                         <i className="fas fa-file-excel me-1"></i> Excel
//                                     </button>

//                                 </div>
//                             </div>
//                         </div>
//                     </div>

//                     <div className="row">
//                         <div className="col-12">
//                             <div className="card shadow-sm">
//                                 <div className="card-header bg-white border-bottom">
//                                     <h5 className="card-title mb-0 text-primary">
//                                         <i className="fas fa-book me-2"></i>
//                                         Ledger Statement
//                                     </h5>
//                                 </div>

//                                 <div className="card-body">
//                                     <form onSubmit={handleSubmit} className="mb-4">
//                                         <div className="row g-3">
//                                             <div className="col-md-2">
//                                                 <label className="form-label text-muted small mb-1">From Date</label>
//                                                 <input
//                                                     type="date"
//                                                     className="form-control border-primary"
//                                                     value={filters.start_date}
//                                                     onChange={(e) => setFilters({ ...filters, start_date: e.target.value })}
//                                                 />
//                                             </div>

//                                             <div className="col-md-2">
//                                                 <label className="form-label text-muted small mb-1">To Date</label>
//                                                 <input
//                                                     type="date"
//                                                     className="form-control border-primary"
//                                                     value={filters.end_date}
//                                                     onChange={(e) => setFilters({ ...filters, end_date: e.target.value })}
//                                                 />
//                                             </div>

//                                             <div className="col-md-3">
//                                                 <label className="form-label text-muted small mb-1">Ledger</label>
//                                                 <Select
//                                                     options={ledgers} // grouped format
//                                                     isSearchable={true}
//                                                     isClearable
//                                                     placeholder="Select Ledger..."
//                                                     value={
//                                                         ledgers
//                                                             .flatMap(group => group.options)
//                                                             .find(opt => opt.value === filters.ledger_id) || null
//                                                     }
//                                                     onChange={(selected) =>
//                                                         setFilters({ ...filters, ledger_id: selected?.value || '' })
//                                                     }
//                                                     className="border-primary"
//                                                     styles={{
//                                                         control: (base) => ({
//                                                             ...base,
//                                                             minHeight: '38px',
//                                                         }),
//                                                         groupHeading: (base) => ({
//                                                             ...base,
//                                                             fontWeight: 'bold',
//                                                             color: '#343a40', // Bootstrap dark text
//                                                             fontSize: '0.9rem',
//                                                             paddingLeft: '4px',
//                                                         }),
//                                                         option: (base, state) => ({
//                                                             ...base,
//                                                             paddingLeft: state.data.__isGroup ? base.paddingLeft : '24px', // indent children
//                                                         }),
//                                                     }}
//                                                 />
//                                             </div>


//                                             <div className="col-md-3">
//                                                 <label className="form-label text-muted small mb-1">Project</label>
//                                                 <Select
//                                                     options={projects}
//                                                     value={projects.find(option => option.value === filters.project_id)}
//                                                     onChange={(selected) => setFilters({ ...filters, project_id: selected?.value || '' })}
//                                                     isClearable
//                                                     placeholder="Select Project..."
//                                                     className="border-primary"
//                                                     styles={{
//                                                         control: (base) => ({
//                                                             ...base,
//                                                             minHeight: '38px'
//                                                         })
//                                                     }}
//                                                 />
//                                             </div>
//                                             <div className="col-md-2">
//                                                 <label className="form-label text-muted small mb-1">Reference No</label>
//                                                 <input
//                                                     type="text"
//                                                     className="form-control border-primary"
//                                                     value={filters.reference_no}
//                                                     onChange={(e) => setFilters({ ...filters, reference_no: e.target.value })
//                                                     }
//                                                     placeholder="Enter Reference No"
//                                                 />
//                                             </div>

//                                             <div className="col-md-12 mt-3">
//                                                 <button
//                                                     type="submit"
//                                                     className="btn btn-primary me-2 px-4"
//                                                     disabled={loading || (!filters.start_date && !filters.end_date && !filters.ledger_id && !filters.project_id && !filters.reference_no)}
//                                                 >
//                                                     {loading ? (
//                                                         <>
//                                                             <span className="spinner-border spinner-border-sm me-1" role="status"></span>
//                                                             Loading...
//                                                         </>
//                                                     ) : (
//                                                         <>
//                                                             <i className="fas fa-search me-1"></i>
//                                                             Generate Report
//                                                         </>
//                                                     )}
//                                                 </button>
//                                                 <button
//                                                     type="button"
//                                                     className="btn btn-outline-secondary px-4"
//                                                     onClick={handleClear}
//                                                     disabled={loading}
//                                                 >
//                                                     <i className="fas fa-eraser me-1"></i>
//                                                     Clear
//                                                 </button>
//                                             </div>
//                                         </div>
//                                     </form>

//                                     {error && (
//                                         <div className="alert alert-danger alert-dismissible fade show" role="alert">
//                                             <i className="fas fa-exclamation-circle me-2"></i>
//                                             {error}
//                                             <button type="button" className="btn-close" onClick={() => setError(null)}></button>
//                                         </div>
//                                     )}

//                                     {loading && !data && (
//                                         <div className="text-center py-5">
//                                             <div className="spinner-border text-primary" style={{ width: '3rem', height: '3rem' }} role="status">
//                                                 <span className="visually-hidden">Loading...</span>
//                                             </div>
//                                             <p className="mt-3 text-muted">Loading ledger statement data...</p>
//                                         </div>
//                                     )}

//                                     {!loading && data && (
//                                         <div className="mt-4">
//                                             <div className="d-flex justify-content-between align-items-center mb-3">
//                                                 <div>
//                                                     <h5 className="text-primary mb-1">
//                                                         <i className="fas fa-file-invoice me-2"></i>
//                                                         {ledgers.flatMap(group => group.options).find(l => l.value === filters.ledger_id)?.label || 'All Ledgers'}
//                                                     </h5>
//                                                     {filters.project_id && (
//                                                         <div className="text-muted small">
//                                                             Project: {projects.find(p => p.value === filters.project_id)?.label || ''}
//                                                         </div>
//                                                     )}
//                                                 </div>
//                                                 <div className="badge bg-light text-dark">
//                                                     <i className="far fa-calendar-alt me-1"></i>
//                                                     {filters.start_date ? format(new Date(filters.start_date), 'MMM dd, yyyy') : 'Beginning'}
//                                                     {' to '}
//                                                     {filters.end_date ? format(new Date(filters.end_date), 'MMM dd, yyyy') : 'Now'}
//                                                 </div>
//                                             </div>

//                                             {/* Summary Cards */}
//                                             <div className="row mb-4">
//                                                 <div className="col-md-4">
//                                                     <div className="card bg-light border">
//                                                         <div className="card-body p-3">
//                                                             <h6 className="card-title text-muted small mb-1">Opening Balance</h6>
//                                                             <div className={`h4 mb-0 ${data.opening_balance?.dc === 'D' ? 'text-danger' : 'text-success'}`}>
//                                                                 {data.opening_balance?.dc === 'D' ? 'Dr' : 'Cr'} {parseFloat(data.opening_balance?.amount || 0).toLocaleString('en-US', { minimumFractionDigits: 2 })}
//                                                             </div>
//                                                         </div>
//                                                     </div>
//                                                 </div>
//                                                 <div className="col-md-4">
//                                                     <div className="card bg-light border">
//                                                         <div className="card-body p-3">
//                                                             <h6 className="card-title text-muted small mb-1">Total Debit</h6>
//                                                             <div className="h4 mb-0 text-danger">
//                                                                 {parseFloat(data.closing_balance?.dr_total || 0).toLocaleString('en-US', { minimumFractionDigits: 2 })}
//                                                             </div>
//                                                         </div>
//                                                     </div>
//                                                 </div>
//                                                 <div className="col-md-4">
//                                                     <div className="card bg-light border">
//                                                         <div className="card-body p-3">
//                                                             <h6 className="card-title text-muted small mb-1">Total Credit</h6>
//                                                             <div className="h4 mb-0 text-success">
//                                                                 {parseFloat(data.closing_balance?.cr_total || 0).toLocaleString('en-US', { minimumFractionDigits: 2 })}
//                                                             </div>
//                                                         </div>
//                                                     </div>
//                                                 </div>
//                                             </div>

//                                             <div className="table-responsive">
//                                                 <table className="table table-hover align-middle">
//                                                     <thead className="table-sales-gradient">
//                                                         <tr>
//                                                             <th style={{ width: '10%' }}>Date</th>
//                                                             <th style={{ width: '12%' }}>Reference</th>
//                                                             <th style={{ width: '38%' }}>Particulars</th>
//                                                             <th style={{ width: '20%' }}>Amount</th>
//                                                             <th style={{ width: '20%' }} className="text-end">Balance</th>
//                                                         </tr>
//                                                     </thead>

//                                                     <tbody>
//                                                         {/* Opening Balance Row */}
//                                                         {data.opening_balance && (
//                                                             <tr className="bg-soft-light">
//                                                                 <td colSpan="3">
//                                                                     <strong>Opening Balance</strong>
//                                                                 </td>
//                                                                 <td className={data.opening_balance?.dc === 'D' ? 'text-danger' : 'text-success'}>
//                                                                     {data.opening_balance?.dc === 'D' ? 'Dr ' : 'Cr '}
//                                                                     {parseFloat(data.opening_balance?.amount || 0).toLocaleString('en-US', { minimumFractionDigits: 2 })}
//                                                                 </td>
//                                                                 <td className="text-end">
//                                                                     <strong className={data.opening_balance?.dc === 'D' ? 'text-danger' : 'text-success'}>
//                                                                         {data.opening_balance?.dc === 'D' ? 'Dr ' : 'Cr '}
//                                                                         {parseFloat(data.opening_balance?.amount || 0).toLocaleString('en-US', { minimumFractionDigits: 2 })}
//                                                                     </strong>
//                                                                 </td>
//                                                             </tr>
//                                                         )}

//                                                         {/* Group entries by transaction ID */}
//                                                         {Object.values(
//                                                             data.entries.reduce((acc, entry) => {
//                                                                 if (!acc[entry.Entry.id]) {
//                                                                     acc[entry.Entry.id] = {
//                                                                         date: entry.Entry.date,
//                                                                         reference: entry.Entry.reference_no,
//                                                                         narration: entry.Entry.narration,
//                                                                         items: []
//                                                                     };
//                                                                 }
//                                                                 acc[entry.Entry.id].items.push(entry);
//                                                                 return acc;
//                                                             }, {})
//                                                         ).map((transaction, index) => {
//                                                             const ledgerEntries = transaction.items.map(item => ({
//                                                                 dc: item.Entryitem.dc,
//                                                                 amount: item.Entryitem.amount,
//                                                                 ledgerId: item.Entryitem.ledger_id,
//                                                                 ledgerName: ledgers.flatMap(g => g.options).find(l => l.value === item.Entryitem.ledger_id)?.label || 'Unknown'
//                                                             }));

//                                                             // Find the selected ledger entry (based on filters.ledger_id)
//                                                             const selectedEntry = transaction.items.find(item =>
//                                                                 String(item.Entryitem.ledger_id) === String(filters.ledger_id)
//                                                             );

//                                                             // If no selected entry found (shouldn't happen since we filtered by ledger_id)
//                                                             if (!selectedEntry) return null;

//                                                             return (
//                                                                 <React.Fragment key={transaction.reference || index}>
//                                                                     <tr>
//                                                                         <td>{format(new Date(transaction.date), 'dd MMM yyyy')}</td>
//                                                                         <td>
//                                                                             <span className="badge bg-soft-primary text-primary">
//                                                                                 {transaction.reference || '-'}
//                                                                             </span>
//                                                                         </td>
//                                                                         <td>
//                                                                             <div>
//                                                                                 <div className="fw-bold">{transaction.narration}</div>
//                                                                                 <div className="small text-muted">
//                                                                                     {ledgerEntries
//                                                                                         .filter(entry => entry.ledgerId !== parseInt(filters.ledger_id)) // show only others
//                                                                                         .map((entry, i) => (
//                                                                                             <div key={i}>
//                                                                                                 <i className={`fas fa-${entry.dc === 'D' ? 'arrow-down text-danger' : 'arrow-up text-success'} me-1`}></i>
//                                                                                                 {entry.ledgerName} ({entry.dc} {parseFloat(entry.amount).toLocaleString('en-US', { minimumFractionDigits: 2 })})
//                                                                                             </div>
//                                                                                         ))}
//                                                                                 </div>
//                                                                             </div>
//                                                                         </td>
//                                                                         <td className={selectedEntry.Entryitem.dc === 'D' ? 'text-danger fw-bold' : 'text-success fw-bold'}>
//                                                                             {/* {ledgerEntries.find(e => e.ledgerId === parseInt(filters.ledger_id))?.ledgerName} */}

//                                                                             {selectedEntry.Entryitem.dc} {parseFloat(selectedEntry.Entryitem.amount || 0).toLocaleString('en-US', { minimumFractionDigits: 2 })}
//                                                                         </td>

//                                                                         <td className="text-end">
//                                                                             {/* Running balance would go here */}
//                                                                         </td>
//                                                                     </tr>
//                                                                 </React.Fragment>
//                                                             );
//                                                         })}

//                                                         {/* Closing Balance Row */}
//                                                         {data.closing_balance && (
//                                                             <tr className="bg-soft-light">
//                                                                 <td colSpan="3">
//                                                                     <strong>Closing Balance</strong>
//                                                                 </td>
//                                                                 <td className={data.closing_balance?.dc === 'D' ? 'text-danger' : 'text-success'}>
//                                                                     {data.closing_balance?.dc === 'D' ? 'Dr ' : 'Cr '}
//                                                                     {parseFloat(data.closing_balance?.amount || 0).toLocaleString('en-US', { minimumFractionDigits: 2 })}
//                                                                 </td>
//                                                                 <td className="text-end">
//                                                                     <strong className={data.closing_balance?.dc === 'D' ? 'text-danger' : 'text-success'}>
//                                                                         {data.closing_balance?.dc === 'D' ? 'Dr ' : 'Cr '}
//                                                                         {parseFloat(data.closing_balance?.amount || 0).toLocaleString('en-US', { minimumFractionDigits: 2 })}
//                                                                     </strong>
//                                                                 </td>
//                                                             </tr>
//                                                         )}
//                                                     </tbody>
//                                                 </table>
//                                             </div>
//                                         </div>
//                                     )}
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// };
// export default LedgerStatement;

import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Select from 'react-select';
import { format } from 'date-fns';
import { saveAs } from 'file-saver';
import Offcanvas from 'react-bootstrap/Offcanvas';
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import "react-datepicker/dist/react-datepicker.css";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import TextField from "@mui/material/TextField";
import dayjs from "dayjs";
import { getAdjustedStartDate, getAdjustedEndDate } from '../../utils/dateHelper';

const safeParseFloat = (val) => {
    if (val === null || val === undefined || val === '') return 0;
    if (typeof val === 'number') return val;
    // Remove commas from string representation
    const sanitized = val.toString().replace(/,/g, '');
    const parsed = parseFloat(sanitized);
    return isNaN(parsed) ? 0 : parsed;
};

// const LedgerStatement = () => {
//     const [data, setData] = useState(null);
//     const [loading, setLoading] = useState(false);
//     const [error, setError] = useState(null);
//     const [projects, setProjects] = useState([]);
//     const [ledgers, setLedgers] = useState([]);
//     const [filters, setFilters] = useState({
//         start_date: '',
//         end_date: '',
//         ledger_id: '',
//         project_id: '',
//         reference_no: ''
//     });
//     const [selectedTransaction, setSelectedTransaction] = useState(null);
//     const [showModal, setShowModal] = useState(false);

//     const API_BASE_URL = process.env.REACT_APP_WEBZASH_URL || 'http://localhost/webzash-integration';
//     const API_KEY = process.env.REACT_APP_API_KEY || 'your_api_key_here';
//     const API_ORIGIN = process.env.REACT_APP_BACKEND_URL;

//     // Fetch projects and ledgers on component mount
//     useEffect(() => {
//         const fetchInitialData = async () => {
//             try {
//                 // Fetch projects
//                 const userInfo = JSON.parse(localStorage.getItem("user-info"));
//                 const origin = localStorage.getItem('user-origin');
//                 const token = userInfo?.token;

//                 const projectsResponse = await axios.get(`${API_ORIGIN}/api/projects`, {
//                     headers: {
//                         Authorization: `Bearer ${token}`,
//                         'Tenant-Origin': origin,
//                     }
//                 });

//                 setProjects(projectsResponse.data?.Data?.map(project => ({
//                     value: project.id,
//                     label: project.name
//                 })));

//                 // Fetch ledgers
//                 const ledgersResponse = await axios.get(`${API_BASE_URL}/api/ledgers/index`, {
//                     headers: {
//                         'x-api-key': API_KEY,
//                         'Accept': 'application/json',
//                     }
//                 });

//                 const grouped = ledgersResponse.data.data.reduce((acc, item) => {
//                     const groupName = item.Group?.name || 'Ungrouped';
//                     if (!acc[groupName]) {
//                         acc[groupName] = [];
//                     }
//                     acc[groupName].push({
//                         value: item.Ledger.id,
//                         label: item.Ledger.name,
//                     });
//                     return acc;
//                 }, {});

//                 const groupedOptions = Object.entries(grouped).map(([label, options]) => ({
//                     label,
//                     options
//                 }));

//                 setLedgers(groupedOptions);

//             } catch (err) {
//                 setError('Failed to load initial data');
//                 console.error('Initial data error:', err);
//             }
//         };

//         fetchInitialData();
//     }, [API_BASE_URL, API_KEY, API_ORIGIN]);

//     const fetchLedgerStatement = async () => {
//         setLoading(true);
//         setError(null);

//         try {
//             const params = new URLSearchParams();
//             if (filters.start_date) params.append('startdate', filters.start_date);
//             if (filters.end_date) params.append('enddate', filters.end_date);
//             if (filters.ledger_id) params.append('ledger_id', filters.ledger_id);
//             if (filters.project_id) params.append('project_id', filters.project_id);
//             if (filters.reference_no) params.append('reference_no', filters.reference_no);

//             // Only make the request if we have at least one filter
//             if (filters.start_date || filters.end_date || filters.ledger_id || filters.project_id || filters.reference_no) {
//                 const response = await axios.get(
//                     `${API_BASE_URL}/api/reports/ledgerstatement`,
//                     {
//                         headers: {
//                             'x-api-key': API_KEY,
//                             'Accept': 'application/json',
//                         },
//                         params
//                     }
//                 );
//                 setData(response.data);
//             } else {
//                 setError('Please select at least one filter criteria');
//             }
//         } catch (err) {
//             setError(err.response?.data?.message || 'Failed to fetch ledger statement');
//             console.error('API Error:', err);
//         } finally {
//             setLoading(false);
//         }
//     };

//     const handleSubmit = (e) => {
//         e.preventDefault();
//         fetchLedgerStatement();
//     };

//     const handleClear = () => {
//         setFilters({
//             start_date: '',
//             end_date: '',
//             ledger_id: '',
//             project_id: '',
//             reference_no: ''
//         });
//         setData(null);
//     };

//     const handleExport = async (formatType) => {
//         try {
//             const params = new URLSearchParams();
//             if (filters.start_date) params.append('startdate', filters.start_date);
//             if (filters.end_date) params.append('enddate', filters.end_date);
//             if (filters.ledger_id) params.append('ledger_id', filters.ledger_id);
//             if (filters.project_id) params.append('project_id', filters.project_id);
//             if (filters.reference_no) params.append('reference_no', filters.reference_no);
//             params.append('format', formatType);

//             const response = await axios.get(
//                 `${API_BASE_URL}/api/reports/ledgerstatement`,
//                 {
//                     headers: {
//                         'x-api-key': API_KEY,
//                         'Accept': 'application/octet-stream'
//                     },
//                     params,
//                     responseType: 'blob'
//                 }
//             );
//             const blob = new Blob([response.data], { type: response.headers['content-type'] });

//             const extension = formatType === 'csv' ? 'csv' : 'xls';
//             saveAs(blob, `ledger_statement_${filters.ledger_id || 'all'}_${filters.start_date || 'start'}_to_${filters.end_date || 'end'}.${extension}`);
//         } catch (err) {
//             setError(`Failed to export ${formatType.toUpperCase()}`);
//             console.error('Export Error:', err);
//         }
//     };

//     const printReport = () => {
//         window.open(
//             `${API_BASE_URL}/api/reports/ledgerstatement?format=print${filters.start_date ? `&startdate=${filters.start_date}` : ''}${filters.end_date ? `&enddate=${filters.end_date}` : ''}${filters.ledger_id ? `&ledger_id=${filters.ledger_id}` : ''}${filters.project_id ? `&project_id=${filters.project_id}` : ''}`,
//             '_blank'
//         );
//     };

//     // Handle opening modal with transaction details
//     const handleTransactionClick = (transaction) => {
//         setSelectedTransaction(transaction);
//         setShowModal(true);
//     };

//     // Calculate running balance
//     const calculateRunningBalance = (entries, openingBalance) => {
//         let balance = parseFloat(openingBalance?.amount || 0);
//         if (openingBalance?.dc === 'C') balance = -balance;

//         return entries.map(entry => {
//             const amount = parseFloat(entry.Entryitem.amount || 0);
//             if (entry.Entryitem.dc === 'D') {
//                 balance += amount;
//             } else {
//                 balance -= amount;
//             }
//             return {
//                 ...entry,
//                 runningBalance: balance
//             };
//         });
//     };

//     const entriesWithBalance = data?.entries ? calculateRunningBalance(data.entries, data.opening_balance) : [];

//     return (
//         <div className="main-content" style={{ backgroundColor: '#f8f9fa' }}>
//             <div className="page-content">
//                 <div className="container-fluid">
//                     <div className="row">
//                         <div className="col-12">
//                             <div className="page-title-box d-flex align-items-center justify-content-between">
//                                 <div>
//                                     <h4 className="mb-0 text-primary">Ledger Statement</h4>
//                                     <ol className="breadcrumb">
//                                         <li className="breadcrumb-item"><a href="#">Reports</a></li>
//                                         <li className="breadcrumb-item active">Ledger Statement</li>
//                                     </ol>
//                                 </div>
//                                 <div className="d-flex gap-2">
//                                     <button
//                                         onClick={() => handleExport('csv')}
//                                         className="btn btn-outline-primary btn-sm"
//                                         disabled={loading || !data}
//                                     >
//                                         <i className="fas fa-file-csv me-1"></i> CSV
//                                     </button>
//                                     <button
//                                         onClick={() => handleExport('xls')}
//                                         className="btn btn-outline-success btn-sm"
//                                         disabled={loading || !data}
//                                     >
//                                         <i className="fas fa-file-excel me-1"></i> Excel
//                                     </button>

//                                 </div>
//                             </div>
//                         </div>
//                     </div>

//                     <div className="row">
//                         <div className="col-12">
//                             <div className="card shadow-sm">
//                                 <div className="card-header bg-white border-bottom">
//                                     <h5 className="card-title mb-0 text-primary">
//                                         <i className="fas fa-book me-2"></i>
//                                         Ledger Statement
//                                     </h5>
//                                 </div>

//                                 <div className="card-body">
//                                     <form onSubmit={handleSubmit} className="mb-4">
//                                         <div className="row g-3">
//                                             <div className="col-md-2">
//                                                 <label className="form-label text-muted small mb-1">From Date</label>
//                                                 <input
//                                                     type="date"
//                                                     className="form-control border-primary"
//                                                     value={filters.start_date}
//                                                     onChange={(e) => setFilters({ ...filters, start_date: e.target.value })}
//                                                 />
//                                             </div>

//                                             <div className="col-md-2">
//                                                 <label className="form-label text-muted small mb-1">To Date</label>
//                                                 <input
//                                                     type="date"
//                                                     className="form-control border-primary"
//                                                     value={filters.end_date}
//                                                     onChange={(e) => setFilters({ ...filters, end_date: e.target.value })}
//                                                 />
//                                             </div>

//                                             <div className="col-md-3">
//                                                 <label className="form-label text-muted small mb-1">Ledger</label>
//                                                 <Select
//                                                     options={ledgers} // grouped format
//                                                     isSearchable={true}
//                                                     isClearable
//                                                     placeholder="Select Ledger..."
//                                                     value={
//                                                         ledgers
//                                                             .flatMap(group => group.options)
//                                                             .find(opt => opt.value === filters.ledger_id) || null
//                                                     }
//                                                     onChange={(selected) =>
//                                                         setFilters({ ...filters, ledger_id: selected?.value || '' })
//                                                     }
//                                                     className="border-primary"
//                                                     styles={{
//                                                         control: (base) => ({
//                                                             ...base,
//                                                             minHeight: '38px',
//                                                         }),
//                                                         groupHeading: (base) => ({
//                                                             ...base,
//                                                             fontWeight: 'bold',
//                                                             color: '#343a40', // Bootstrap dark text
//                                                             fontSize: '0.9rem',
//                                                             paddingLeft: '4px',
//                                                         }),
//                                                         option: (base, state) => ({
//                                                             ...base,
//                                                             paddingLeft: state.data.__isGroup ? base.paddingLeft : '24px', // indent children
//                                                         }),
//                                                     }}
//                                                 />
//                                             </div>


//                                             <div className="col-md-3">
//                                                 <label className="form-label text-muted small mb-1">Project</label>
//                                                 <Select
//                                                     options={projects}
//                                                     value={projects.find(option => option.value === filters.project_id)}
//                                                     onChange={(selected) => setFilters({ ...filters, project_id: selected?.value || '' })}
//                                                     isClearable
//                                                     placeholder="Select Project..."
//                                                     className="border-primary"
//                                                     styles={{
//                                                         control: (base) => ({
//                                                             ...base,
//                                                             minHeight: '38px'
//                                                         })
//                                                     }}
//                                                 />
//                                             </div>
//                                             <div className="col-md-2">
//                                                 <label className="form-label text-muted small mb-1">Reference No</label>
//                                                 <input
//                                                     type="text"
//                                                     className="form-control border-primary"
//                                                     value={filters.reference_no}
//                                                     onChange={(e) => setFilters({ ...filters, reference_no: e.target.value })
//                                                     }
//                                                     placeholder="Enter Reference No"
//                                                 />
//                                             </div>

//                                             <div className="col-md-12 mt-3">
//                                                 <button
//                                                     type="submit"
//                                                     className="btn btn-primary me-2 px-4"
//                                                     disabled={loading || (!filters.start_date && !filters.end_date && !filters.ledger_id && !filters.project_id && !filters.reference_no)}
//                                                 >
//                                                     {loading ? (
//                                                         <>
//                                                             <span className="spinner-border spinner-border-sm me-1" role="status"></span>
//                                                             Loading...
//                                                         </>
//                                                     ) : (
//                                                         <>
//                                                             <i className="fas fa-search me-1"></i>
//                                                             Generate Report
//                                                         </>
//                                                     )}
//                                                 </button>
//                                                 <button
//                                                     type="button"
//                                                     className="btn btn-outline-secondary px-4"
//                                                     onClick={handleClear}
//                                                     disabled={loading}
//                                                 >
//                                                     <i className="fas fa-eraser me-1"></i>
//                                                     Clear
//                                                 </button>
//                                             </div>
//                                         </div>
//                                     </form>

//                                     {error && (
//                                         <div className="alert alert-danger alert-dismissible fade show" role="alert">
//                                             <i className="fas fa-exclamation-circle me-2"></i>
//                                             {error}
//                                             <button type="button" className="btn-close" onClick={() => setError(null)}></button>
//                                         </div>
//                                     )}

//                                     {loading && !data && (
//                                         <div className="text-center py-5">
//                                             <div className="spinner-border text-primary" style={{ width: '3rem', height: '3rem' }} role="status">
//                                                 <span className="visually-hidden">Loading...</span>
//                                             </div>
//                                             <p className="mt-3 text-muted">Loading ledger statement data...</p>
//                                         </div>
//                                     )}

//                                     {!loading && data && (
//                                         <div className="mt-4">
//                                             <div className="d-flex justify-content-between align-items-center mb-3">
//                                                 <div>
//                                                     <h5 className="text-primary mb-1">
//                                                         <i className="fas fa-file-invoice me-2"></i>
//                                                         {ledgers.flatMap(group => group.options).find(l => l.value === filters.ledger_id)?.label || 'All Ledgers'}
//                                                     </h5>
//                                                     {filters.project_id && (
//                                                         <div className="text-muted small">
//                                                             Project: {projects.find(p => p.value === filters.project_id)?.label || ''}
//                                                         </div>
//                                                     )}
//                                                 </div>
//                                                 <div className="badge bg-light text-dark">
//                                                     <i className="far fa-calendar-alt me-1"></i>
//                                                     {filters.start_date ? format(new Date(filters.start_date), 'MMM dd, yyyy') : 'Beginning'}
//                                                     {' to '}
//                                                     {filters.end_date ? format(new Date(filters.end_date), 'MMM dd, yyyy') : 'Now'}
//                                                 </div>
//                                             </div>

//                                             {/* Summary Cards */}
//                                             <div className="row mb-4">
//                                                 <div className="col-md-4">
//                                                     <div className="card bg-light border">
//                                                         <div className="card-body p-3">
//                                                             <h6 className="card-title text-muted small mb-1">Opening Balance</h6>
//                                                             <div className={`h4 mb-0 ${data.opening_balance?.dc === 'D' ? 'text-danger' : 'text-success'}`}>
//                                                                 {data.opening_balance?.dc === 'D' ? 'Dr' : 'Cr'} {parseFloat(data.opening_balance?.amount || 0).toLocaleString('en-US', { minimumFractionDigits: 2 })}
//                                                             </div>
//                                                         </div>
//                                                     </div>
//                                                 </div>
//                                                 <div className="col-md-4">
//                                                     <div className="card bg-light border">
//                                                         <div className="card-body p-3">
//                                                             <h6 className="card-title text-muted small mb-1">Total Debit</h6>
//                                                             <div className="h4 mb-0 text-danger">
//                                                                 {parseFloat(data.closing_balance?.dr_total || 0).toLocaleString('en-US', { minimumFractionDigits: 2 })}
//                                                             </div>
//                                                         </div>
//                                                     </div>
//                                                 </div>
//                                                 <div className="col-md-4">
//                                                     <div className="card bg-light border">
//                                                         <div className="card-body p-3">
//                                                             <h6 className="card-title text-muted small mb-1">Total Credit</h6>
//                                                             <div className="h4 mb-0 text-success">
//                                                                 {parseFloat(data.closing_balance?.cr_total || 0).toLocaleString('en-US', { minimumFractionDigits: 2 })}
//                                                             </div>
//                                                         </div>
//                                                     </div>
//                                                 </div>
//                                             </div>

//                                             <div className="table-responsive">
//                                                 <table className="table table-hover align-middle">
//                                                     <thead className="table-sales-gradient">
//                                                         <tr>
//                                                             <th style={{ width: '10%' }}>Date</th>
//                                                             <th style={{ width: '12%' }}>Reference</th>
//                                                             <th style={{ width: '38%' }}>Particulars</th>
//                                                             <th style={{ width: '20%' }}>Amount</th>
//                                                             <th style={{ width: '20%' }} className="text-end">Balance</th>
//                                                         </tr>
//                                                     </thead>

//                                                     <tbody>
//                                                         {/* Opening Balance Row */}
//                                                         {data.opening_balance && (
//                                                             <tr className="bg-soft-light">
//                                                                 <td colSpan="3">
//                                                                     <strong>Opening Balance</strong>
//                                                                 </td>
//                                                                 <td className={data.opening_balance?.dc === 'D' ? 'text-danger' : 'text-success'}>
//                                                                     {data.opening_balance?.dc === 'D' ? 'Dr ' : 'Cr '}
//                                                                     {parseFloat(data.opening_balance?.amount || 0).toLocaleString('en-US', { minimumFractionDigits: 2 })}
//                                                                 </td>
//                                                                 <td className="text-end">
//                                                                     <strong className={data.opening_balance?.dc === 'D' ? 'text-danger' : 'text-success'}>
//                                                                         {data.opening_balance?.dc === 'D' ? 'Dr ' : 'Cr '}
//                                                                         {parseFloat(data.opening_balance?.amount || 0).toLocaleString('en-US', { minimumFractionDigits: 2 })}
//                                                                     </strong>
//                                                                 </td>
//                                                             </tr>
//                                                         )}

//                                                         {/* Group entries by transaction ID */}
//                                                         {Object.values(
//                                                             data.entries.reduce((acc, entry) => {
//                                                                 if (!acc[entry.Entry.id]) {
//                                                                     acc[entry.Entry.id] = {
//                                                                         id: entry.Entry.id,
//                                                                         date: entry.Entry.date,
//                                                                         reference: entry.Entry.reference_no,
//                                                                         narration: entry.Entry.narration,
//                                                                         items: []
//                                                                     };
//                                                                 }
//                                                                 acc[entry.Entry.id].items.push(entry);
//                                                                 return acc;
//                                                             }, {})
//                                                         ).map((transaction, index) => {
//                                                             const ledgerEntries = transaction.items.map(item => ({
//                                                                 dc: item.Entryitem.dc,
//                                                                 amount: item.Entryitem.amount,
//                                                                 ledgerId: item.Entryitem.ledger_id,
//                                                                 ledgerName: ledgers.flatMap(g => g.options).find(l => l.value === item.Entryitem.ledger_id)?.label || 'Unknown'
//                                                             }));

//                                                             // Find the selected ledger entry (based on filters.ledger_id)
//                                                             const selectedEntry = transaction.items.find(item =>
//                                                                 String(item.Entryitem.ledger_id) === String(filters.ledger_id)
//                                                             );

//                                                             // If no selected entry found (shouldn't happen since we filtered by ledger_id)
//                                                             if (!selectedEntry) return null;

//                                                             return (
//                                                                 <React.Fragment key={transaction.reference || index}>
//                                                                     <tr>
//                                                                         <td 
//                                                                             style={{cursor: 'pointer'}}
//                                                                             onClick={() => handleTransactionClick(transaction)}
//                                                                         >
//                                                                             {format(new Date(transaction.date), 'dd MMM yyyy')}
//                                                                         </td>
//                                                                         <td>
//                                                                             <span 
//                                                                                 className="badge bg-soft-primary text-primary"
//                                                                                 style={{cursor: 'pointer'}}
//                                                                                 onClick={() => handleTransactionClick(transaction)}
//                                                                             >
//                                                                                 {transaction.reference || '-'}
//                                                                             </span>
//                                                                         </td>
//                                                                         <td>
//                                                                             <div>
//                                                                                 <div className="fw-bold">{transaction.narration}</div>
//                                                                                 <div className="small text-muted">
//                                                                                     {ledgerEntries
//                                                                                         .filter(entry => entry.ledgerId !== parseInt(filters.ledger_id)) // show only others
//                                                                                         .map((entry, i) => (
//                                                                                             <div key={i}>
//                                                                                                 <i className={`fas fa-${entry.dc === 'D' ? 'arrow-down text-danger' : 'arrow-up text-success'} me-1`}></i>
//                                                                                                 {entry.ledgerName} ({entry.dc} {parseFloat(entry.amount).toLocaleString('en-US', { minimumFractionDigits: 2 })})
//                                                                                             </div>
//                                                                                         ))}
//                                                                                 </div>
//                                                                             </div>
//                                                                         </td>
//                                                                         <td className={selectedEntry.Entryitem.dc === 'D' ? 'text-danger fw-bold' : 'text-success fw-bold'}>
//                                                                             {selectedEntry.Entryitem.dc} {parseFloat(selectedEntry.Entryitem.amount || 0).toLocaleString('en-US', { minimumFractionDigits: 2 })}
//                                                                         </td>

//                                                                         <td className="text-end">
//                                                                             {/* Running balance would go here */}
//                                                                         </td>
//                                                                     </tr>
//                                                                 </React.Fragment>
//                                                             );
//                                                         })}

//                                                         {/* Closing Balance Row */}
//                                                         {data.closing_balance && (
//                                                             <tr className="bg-soft-light">
//                                                                 <td colSpan="3">
//                                                                     <strong>Closing Balance</strong>
//                                                                 </td>
//                                                                 <td className={data.closing_balance?.dc === 'D' ? 'text-danger' : 'text-success'}>
//                                                                     {data.closing_balance?.dc === 'D' ? 'Dr ' : 'Cr '}
//                                                                     {parseFloat(data.closing_balance?.amount || 0).toLocaleString('en-US', { minimumFractionDigits: 2 })}
//                                                                 </td>
//                                                                 <td className="text-end">
//                                                                     <strong className={data.closing_balance?.dc === 'D' ? 'text-danger' : 'text-success'}>
//                                                                         {data.closing_balance?.dc === 'D' ? 'Dr ' : 'Cr '}
//                                                                         {parseFloat(data.closing_balance?.amount || 0).toLocaleString('en-US', { minimumFractionDigits: 2 })}
//                                                                     </strong>
//                                                                 </td>
//                                                             </tr>
//                                                         )}
//                                                     </tbody>
//                                                 </table>
//                                             </div>
//                                         </div>
//                                     )}
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>

//             {/* Transaction Details Offcanvas Modal */}
//             <Offcanvas 
//                 show={showModal} 
//                 onHide={() => setShowModal(false)} 
//                 placement="end"
//                 style={{width: '600px'}}
//             >
//                 <Offcanvas.Header closeButton className="border-bottom">
//                     <Offcanvas.Title className="text-primary">
//                         <i className="fas fa-receipt me-2"></i>
//                         Transaction Details
//                     </Offcanvas.Title>
//                 </Offcanvas.Header>
//                 <Offcanvas.Body>
//                     {selectedTransaction && (
//                         <div>
//                             {/* Transaction Header Card */}
//                             <div className="card shadow-sm mb-4 border-0 bg-light">
//                                 <div className="card-body">
//                                     <div className="d-flex justify-content-between align-items-center mb-3">
//                                         <div>
//                                             <h6 className="text-muted mb-1">Transaction Date</h6>
//                                             <p className="mb-0 fw-bold">{format(new Date(selectedTransaction.date), 'dd MMM yyyy')}</p>
//                                         </div>
//                                         <div className="text-end">
//                                             <h6 className="text-muted mb-1">Reference No</h6>
//                                             <span className="badge bg-primary">{selectedTransaction.reference || 'N/A'}</span>
//                                         </div>
//                                     </div>

//                                     <div className="mt-3">
//                                         <h6 className="text-muted mb-1">Narration</h6>
//                                         <p className="mb-0 fw-semibold">{selectedTransaction.narration}</p>
//                                     </div>
//                                 </div>
//                             </div>

//                             {/* Ledger Entries Section */}
//                             <h6 className="text-muted mb-3">
//                                 <i className="fas fa-list me-1"></i>
//                                 Ledger Entries
//                             </h6>

//                             {selectedTransaction.items.map((item, index) => {
//                                 const ledgerName = ledgers.flatMap(g => g.options).find(l => l.value === item.Entryitem.ledger_id)?.label || 'Unknown';
//                                 const isDebit = item.Entryitem.dc === 'D';

//                                 return (
//                                     <div key={index} className="card mb-3 border-0 shadow-sm">
//                                         <div className="card-body py-3">
//                                             <div className="d-flex justify-content-between align-items-center">
//                                                 <div>
//                                                     <h6 className="mb-1 fw-semibold">{ledgerName}</h6>
//                                                     <span className={`badge ${isDebit ? 'bg-danger' : 'bg-success'}`}>
//                                                         {isDebit ? 'Debit' : 'Credit'}
//                                                     </span>
//                                                 </div>
//                                                 <div className={`h5 mb-0 ${isDebit ? 'text-danger' : 'text-success'}`}>
//                                                     {parseFloat(item.Entryitem.amount || 0).toLocaleString('en-US', { minimumFractionDigits: 2 })}
//                                                 </div>
//                                             </div>
//                                         </div>
//                                     </div>
//                                 );
//                             })}

//                             {/* Summary Section */}
//                             <div className="mt-4 pt-3 border-top">
//                                 <h6 className="text-muted mb-3">
//                                     <i className="fas fa-calculator me-1"></i>
//                                     Transaction Summary
//                                 </h6>

//                                 <div className="d-flex justify-content-between align-items-center mb-2">
//                                     <span className="fw-semibold">Total Debit:</span>
//                                     <span className="text-danger fw-bold">
//                                         {selectedTransaction.items
//                                             .filter(item => item.Entryitem.dc === 'D')
//                                             .reduce((sum, item) => sum + parseFloat(item.Entryitem.amount || 0), 0)
//                                             .toLocaleString('en-US', { minimumFractionDigits: 2 })}
//                                     </span>
//                                 </div>

//                                 <div className="d-flex justify-content-between align-items-center mb-2">
//                                     <span className="fw-semibold">Total Credit:</span>
//                                     <span className="text-success fw-bold">
//                                         {selectedTransaction.items
//                                             .filter(item => item.Entryitem.dc === 'C')
//                                             .reduce((sum, item) => sum + parseFloat(item.Entryitem.amount || 0), 0)
//                                             .toLocaleString('en-US', { minimumFractionDigits: 2 })}
//                                     </span>
//                                 </div>

//                                 <div className="d-flex justify-content-between align-items-center mt-3 pt-2 border-top">
//                                     <span className="fw-bold">Balance:</span>
//                                     <span className={`fw-bold ${
//                                         Math.abs(
//                                             selectedTransaction.items
//                                                 .filter(item => item.Entryitem.dc === 'D')
//                                                 .reduce((sum, item) => sum + parseFloat(item.Entryitem.amount || 0), 0) -
//                                             selectedTransaction.items
//                                                 .filter(item => item.Entryitem.dc === 'C')
//                                                 .reduce((sum, item) => sum + parseFloat(item.Entryitem.amount || 0), 0)
//                                         ) < 0.01 ? 'text-muted' : 'text-warning'
//                                     }`}>
//                                         {Math.abs(
//                                             selectedTransaction.items
//                                                 .filter(item => item.Entryitem.dc === 'D')
//                                                 .reduce((sum, item) => sum + parseFloat(item.Entryitem.amount || 0), 0) -
//                                             selectedTransaction.items
//                                                 .filter(item => item.Entryitem.dc === 'C')
//                                                 .reduce((sum, item) => sum + parseFloat(item.Entryitem.amount || 0), 0)
//                                         ).toLocaleString('en-US', { minimumFractionDigits: 2 })}
//                                         {Math.abs(
//                                             selectedTransaction.items
//                                                 .filter(item => item.Entryitem.dc === 'D')
//                                                 .reduce((sum, item) => sum + parseFloat(item.Entryitem.amount || 0), 0) -
//                                             selectedTransaction.items
//                                                 .filter(item => item.Entryitem.dc === 'C')
//                                                 .reduce((sum, item) => sum + parseFloat(item.Entryitem.amount || 0), 0)
//                                         ) < 0.01 ? ' (Balanced)' : ' (Imbalanced)'}
//                                     </span>
//                                 </div>
//                             </div>
//                         </div>
//                     )}
//                 </Offcanvas.Body>
//             </Offcanvas>
//         </div>
//     );
// };

const LedgerStatement = () => {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [projects, setProjects] = useState([]);
    const [ledgers, setLedgers] = useState([]);
    const [filters, setFilters] = useState({
        start_date: '',
        end_date: '',
        ledger_id: '',
        project_id: '',
        reference_no: '',
        dateRange: 'yearly'
    });
    const [selectedYear, setSelectedYear] = useState(null);
    const [selectedEndYear, setSelectedEndYear] = useState(null);

    const handleDateRangeChange = (value) => {
        setFilters(prev => ({ ...prev, dateRange: value }));
        if (value === 'yearly') {
            setSelectedYear(null);
            setSelectedEndYear(null);
            setFilters(prev => ({ ...prev, start_date: '', end_date: '' }));
        }
    };
    const [selectedTransaction, setSelectedTransaction] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [bankAccounts, setBankAccounts] = useState([]);
    const [companySettings, setCompanySettings] = useState(null);

    const API_BASE_URL = process.env.REACT_APP_WEBZASH_URL || 'http://localhost/webzash-integration';
    const API_KEY = process.env.REACT_APP_API_KEY || 'your_api_key_here';
    const API_ORIGIN = process.env.REACT_APP_BACKEND_URL;

    // Fetch projects and ledgers on component mount
    useEffect(() => {
        const fetchInitialData = async () => {
            try {
                // Fetch projects
                const userInfo = JSON.parse(localStorage.getItem("user-info"));
                const origin = localStorage.getItem('user-origin');
                const token = userInfo?.token;

                const projectsResponse = await axios.get(`${API_ORIGIN}/api/projects?all=true`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Tenant-Origin': origin,
                    }
                });

                setProjects(projectsResponse.data?.Data?.map(project => ({
                    value: project.id,
                    label: project.name
                })));

                // Fetch ledgers
                const ledgersResponse = await axios.get(`${API_BASE_URL}/api/ledgers/index`, {
                    headers: {
                        'x-api-key': API_KEY,
                        'Accept': 'application/json',
                    }
                });

                const grouped = ledgersResponse.data.data.reduce((acc, item) => {
                    const groupName = item.Group?.name || 'Ungrouped';
                    if (!acc[groupName]) {
                        acc[groupName] = [];
                    }
                    acc[groupName].push({
                        value: item.Ledger.id,
                        label: item.Ledger.name,
                    });
                    return acc;
                }, {});

                const groupedOptions = Object.entries(grouped).map(([label, options]) => ({
                    label,
                    options
                }));

                setLedgers(groupedOptions);

            } catch (err) {
                setError('Failed to load initial data');
                console.error('Initial data error:', err);
            }
        };

        fetchInitialData();

        // Fetch bank accounts and settings
        const fetchAdditionalData = async () => {
            try {
                const apiKey = process.env.REACT_APP_API_KEY || 'your_api_key_here';
                const userInfo = JSON.parse(localStorage.getItem("user-info"));
                const origin = localStorage.getItem('user-origin');
                const token = userInfo?.token;

                const bankResponse = await axios.get(`${API_ORIGIN}/api/bank-accounts`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Tenant-Origin': origin,
                    }
                });
                setBankAccounts(bankResponse.data.account || []);

                const settingsResponse = await axios.get(`${API_ORIGIN}/api/settings`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Tenant-Origin': origin,
                    }
                });
                setCompanySettings(settingsResponse.data?.setting);
            } catch (err) {
                console.error('Additional data error:', err);
            }
        };
        fetchAdditionalData();
    }, [API_BASE_URL, API_KEY, API_ORIGIN]);

    const fetchLedgerStatement = async () => {
        setLoading(true);
        setError(null);

        try {
            const params = new URLSearchParams();
            if (filters.start_date) params.append('start_date', filters.start_date);
            if (filters.end_date) params.append('end_date', filters.end_date);
            if (filters.ledger_id) params.append('ledger_id', filters.ledger_id);
            if (filters.project_id) params.append('project_id', filters.project_id);
            if (filters.reference_no) params.append('reference_no', filters.reference_no);

            // Only make the request if we have at least one filter
            if (filters.start_date || filters.end_date || filters.ledger_id || filters.project_id || filters.reference_no) {
                const userInfo = JSON.parse(localStorage.getItem('user-info'));
                const origin = localStorage.getItem('user-origin');
                const token = userInfo?.token;

                const response = await axios.get(
                    `${API_ORIGIN}/api/ledger-statement`,
                    {
                        headers: {
                            'Authorization': `Bearer ${token}`,
                            'Tenant-Origin': origin,
                            'Accept': 'application/json',
                        },
                        params,
                        skipLoader: true
                    }
                );
                setData(response.data);

                // Step 1: Capture Ledger data for comparison
                const debugData = (response.data.entries || []).map(e => ({
                    id: e.Entry?.id,
                    reference: e.Entry?.reference,
                    narration: e.Entry?.narration || e.EntryItem?.narration || "No Narration",
                    amount: e.EntryItem?.amount || e.EntryItem?.dr_amount || e.EntryItem?.cr_amount || 0,
                    dc: e.EntryItem?.dc
                }));
                localStorage.setItem('debugLedgerStatement', JSON.stringify(debugData));

                // Step 2: Define the Comparison Utility (Cross-Tab Support)
                window.compareExpenses = () => {
                    const status = localStorage.getItem('debugAllExpenses_Status');
                    if (status === 'fetching') {
                        console.log("%c⏳ Please wait... Still fetching the full list of expenses (up to 1000). Try again in 2 seconds.", "color: orange; font-weight: bold;");
                        return;
                    }

                    const report = JSON.parse(localStorage.getItem('debugExpenseReport') || '[]');
                    const list = JSON.parse(localStorage.getItem('debugAllExpenses') || '[]');
                    const ledger = JSON.parse(localStorage.getItem('debugLedgerStatement') || '[]');
                    const listIds = list.map(e => e.id);
                    
                    const missedInList = report.filter(e => {
                        // 1. Exact ID match
                        if (e.id && listIds.includes(e.id)) return false;
                        
                        // 2. Loose match: Amount + Date + Narration
                        // This handles cases where ID is missing but it's clearly the same record
                        return !list.some(l => 
                            (Math.abs(Number(l.amount) - Number(e.amount)) < 0.01) &&
                            (l.date === e.date || !e.date) && // Match date if available
                            (l.narration && e.narration && l.narration.toLowerCase().substring(0, 5) === e.narration.toLowerCase().substring(0, 5))
                        );
                    });

                    if (missedInList.length > 0) {
                        console.log(`%c❌ Found ${missedInList.length} items in Report missing from List:`, "color: red; font-weight: bold;");
                        let totalMissingAmount = 0;
                        missedInList.forEach(e => {
                            const amt = Number(e.amount) || 0;
                            totalMissingAmount += amt;
                            console.log(`   - [Date: ${e.date || 'N/A'}] "${e.narration}" | Amt: ${amt.toFixed(2)}`);
                        });
                        console.log(`%c💰 TOTAL MISSING AMOUNT: ${totalMissingAmount.toFixed(2)}`, "color: red; font-weight: bold; font-size: 14px;");
                    }
                    if (ledger.length > 0) {
                        console.log(`%c📑 [LEDGER AUDIT: EXPENSES vs JOURNALS]`, "color: white; background: purple; padding: 5px; font-weight: bold;");
                        
                        // 1. ORPHAN JOURNALS: Ledger entries not found in Report or List
                        const orphanJournals = ledger.filter(l => {
                            const inReport = report.some(e => Number(e.journal_id) === Number(l.id));
                            const inList = list.some(e => Number(e.journal_id) === Number(l.id));
                            if (inReport || inList) return false;
                            
                            // Loose match fallback (Amount + Narration)
                            return !report.some(e => Math.abs(e.amount - l.amount) < 0.05 && e.narration?.substring(0, 5) === l.narration?.substring(0, 5));
                        });

                        // 2. MISSING LEDGER ENTRIES: Expenses that have a journal_id not found in this Ledger view
                        const ledgerIds = ledger.map(l => Number(l.id));
                        const missingInLedger = report.filter(e => e.journal_id && !ledgerIds.includes(Number(e.journal_id)));

                        if (orphanJournals.length > 0) {
                            console.log(`%c⚠️ Found ${orphanJournals.length} Ledger entries NOT linked to any Expense:`, "color: orange; font-weight: bold;");
                            orphanJournals.forEach(l => console.log(`   - [ID: ${l.id}] "${l.narration}" | Amt: ${l.amount.toFixed(2)}`));
                        }

                        if (missingInLedger.length > 0) {
                            console.log(`%c🚨 Found ${missingInLedger.length} Expenses whose Journal entries are MISSING from this Ledger view:`, "color: red; font-weight: bold;");
                            missingInLedger.forEach(e => console.log(`   - [Jrn ID: ${e.journal_id}] "${e.narration}" | Amt: ${e.amount.toFixed(2)} (${e.payment_status})`));
                        }

                        if (orphanJournals.length === 0 && missingInLedger.length === 0) {
                            console.log("✅ All Expenses match the Ledger entries perfectly.");
                        }
                    } else {
                        console.log("%c💡 Note: Ledger data empty. Load Ledger tab & search to include it.", "color: gray; font-style: italic;");
                    }
                };

                console.log("📊 [LedgerStatement] Data Saved to LocalStorage (Cross-tab ready)");
                console.log("🛠️ Type 'compareExpenses()' in ANY tab to see results.");
            } else {
                setError('Please select at least one filter criteria');
            }
        } catch (err) {
            setError(err.response?.data?.message || 'Failed to fetch ledger statement');
            console.error('API Error:', err);
        } finally {
            setLoading(false);
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        fetchLedgerStatement();
    };

    const handleClear = () => {
        setFilters({
            start_date: '',
            end_date: '',
            ledger_id: '',
            project_id: '',
            reference_no: '',
            dateRange: 'yearly'
        });
        setSelectedYear(null);
        setSelectedEndYear(null);
        setData(null);
    };

    const handleExport = async (formatType) => {
        try {
            const params = new URLSearchParams();
            if (filters.start_date) params.append('start_date', filters.start_date);
            if (filters.end_date) params.append('end_date', filters.end_date);
            if (filters.ledger_id) params.append('ledger_id', filters.ledger_id);
            if (filters.project_id) params.append('project_id', filters.project_id);
            if (filters.reference_no) params.append('reference_no', filters.reference_no);
            params.append('format', formatType);

            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const response = await axios.get(
                `${API_ORIGIN}/api/ledger-statement`,
                {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Tenant-Origin': origin,
                        'Accept': 'application/octet-stream'
                    },
                    params,
                    responseType: 'blob',
                    skipLoader: true
                }
            );
            const blob = new Blob([response.data], { type: response.headers['content-type'] });

            const extension = formatType === 'csv' ? 'csv' : 'xls';
            saveAs(blob, `ledger_statement_${filters.ledger_id || 'all'}_${filters.start_date || 'start'}_to_${filters.end_date || 'end'}.${extension}`);
        } catch (err) {
            setError(`Failed to export ${formatType.toUpperCase()}`);
            console.error('Export Error:', err);
        }
    };

    const printReport = () => {
        window.open(
            `${API_BASE_URL}/api/reports/ledgerstatement?format=print${filters.start_date ? `&start_date=${filters.start_date}` : ''}${filters.end_date ? `&enddate=${filters.end_date}` : ''}${filters.ledger_id ? `&ledger_id=${filters.ledger_id}` : ''}${filters.project_id ? `&project_id=${filters.project_id}` : ''}`,
            '_blank'
        );
    };

    // Handle opening modal with transaction details
    const handleTransactionClick = (transaction) => {
        setSelectedTransaction(transaction);
        setShowModal(true);
    };

    const entriesWithBalance = React.useMemo(() => {
        if (!data || !data.entries) return [];

        // 1. Group items by Entry ID to ensure one row per transaction
        const entryGroups = (data.entries || []).reduce((acc, item) => {
            const entryId = item.Entry.id;
            if (!acc[entryId]) {
                acc[entryId] = {
                    id: entryId,
                    date: item.Entry.date,
                    reference: item.Entry.reference_no,
                    narration: item.Entry.narration,
                    items: [],
                    netLedgerAmount: 0
                };
            }
            acc[entryId].items.push(item);

            // Accumulate net change for the selected ledger within this transaction
            if (String(item.Entryitem.ledger_id) === String(filters.ledger_id)) {
                const amount = safeParseFloat(item.Entryitem.amount);
                if (item.Entryitem.dc === 'D') {
                    acc[entryId].netLedgerAmount += amount;
                } else {
                    acc[entryId].netLedgerAmount -= amount;
                }
            }
            return acc;
        }, {});

        // 2. Sort groups by Date and then ID as a consistent tie-breaker
        const sortedTransactions = Object.values(entryGroups).sort((a, b) => {
            const dateA = new Date(a.date);
            const dateB = new Date(b.date);
            if (dateA < dateB) return -1;
            if (dateA > dateB) return 1;
            return a.id - b.id;
        });

        // 3. Calculate running balance on the sorted groups
        let balance = safeParseFloat(data.opening_balance?.amount || 0);
        if (data.opening_balance?.dc === 'C') balance = -balance;

        return sortedTransactions.map(transaction => {
            balance += transaction.netLedgerAmount;
            return {
                ...transaction,
                runningBalance: balance
            };
        });
    }, [data, filters.ledger_id]);


    // Format amount with proper debit/credit display
    const formatAmount = (amount, dc) => {
        const formattedAmount = safeParseFloat(amount || 0).toLocaleString('en-US', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });
        return (formattedAmount !== '0.00' && formattedAmount !== '0') ? formattedAmount : '';
    };


    // Format balance display
    const formatBalance = (balance) => {
        if (balance === 0) return '0.00';
        const absBalance = Math.abs(balance);
        const formatted = absBalance.toLocaleString('en-US', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });
        return balance > 0 ? `Dr ${formatted}` : `Cr ${formatted}`;
    };

    return (
        <div className="main-content" style={{ backgroundColor: '#f8f9fa' }}>
            <div className="page-content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12">
                            <div className="page-title-box d-flex align-items-center justify-content-between">
                                <div>
                                    <h4 className="mb-0 text-primary">Ledger Statement</h4>
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item"><a href="#">Reports</a></li>
                                        <li className="breadcrumb-item active">Ledger Statement</li>
                                    </ol>
                                </div>
                                {/* <div className="d-flex gap-2">
                                    <button
                                        onClick={() => handleExport('csv')}
                                        className="btn btn-outline-primary btn-sm"
                                        disabled={loading || !data}
                                    >
                                        <i className="fas fa-file-csv me-1"></i> CSV
                                    </button>
                                    <button
                                        onClick={() => handleExport('xls')}
                                        className="btn btn-outline-success btn-sm"
                                        disabled={loading || !data}
                                    >
                                        <i className="fas fa-file-excel me-1"></i> Excel
                                    </button>
                                </div> */}
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-12">
                            <div className="card shadow-sm">
                                <div className="card-header bg-white border-bottom">
                                    <h5 className="card-title mb-0 text-primary">
                                        <i className="fas fa-book me-2"></i>
                                        Ledger Statement
                                    </h5>
                                </div>

                                <div className="card-body">
                                    <form onSubmit={handleSubmit} className="mb-4">
                                        <div className="row g-3">
                                            {/* <div className="col-md-2">
                                                <label className="form-label text-muted small mb-1">From Date</label>
                                                <input
                                                    type="date"
                                                    className="form-control border-primary"
                                                    value={filters.start_date}
                                                    onChange={(e) => setFilters({ ...filters, start_date: e.target.value })}

                                                />
                                            </div>

                                            <div className="col-md-2">
                                                <label className="form-label text-muted small mb-1">To Date</label>
                                                <input
                                                    type="date"
                                                    className="form-control border-primary"
                                                    value={filters.end_date}
                                                    onChange={(e) => setFilters({ ...filters, end_date: e.target.value })}
                                                  
                                                />
                                            </div> */}
                                            <div className="col-md-2">
                                                <label className="form-label text-muted small mb-1">Date Range</label>
                                                <select
                                                    className="form-select form-select-sm"
                                                    value={filters.dateRange}
                                                    onChange={(e) => handleDateRangeChange(e.target.value)}
                                                >
                                                    <option value="yearly">Yearly</option>
                                                    <option value="custom">Custom Range</option>
                                                </select>
                                            </div>

                                            {filters.dateRange === 'yearly' && (
                                                <>
                                                    <div className="col-lg-2 col-md-3">
                                                        <label className="form-label font-size-12 text-uppercase fw-bold text-muted mb-1">Start Date</label>
                                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                            <DatePicker
                                                                views={["year", "month", "day"]}
                                                                openTo="year"
                                                                format="DD-MM-YYYY"
                                                                value={filters.start_date ? dayjs(filters.start_date) : null}
                                                                onChange={(newValue) => {
                                                                    if (newValue) {
                                                                        setSelectedYear(newValue);
                                                                        if (!filters.start_date || dayjs(filters.start_date).year() !== newValue.year()) {
                                                                            const start = newValue.startOf('year');
                                                                            const end = newValue.endOf('year');
                                                                            setFilters(prev => ({
                                                                                ...prev,
                                                                                start_date: start.format('YYYY-MM-DD'),
                                                                                end_date: end.format('YYYY-MM-DD')
                                                                            }));
                                                                            setSelectedEndYear(newValue);
                                                                        } else {
                                                                            const { startDate: newStart, suggestedEndDate } = getAdjustedStartDate(newValue, filters.end_date);
                                                                            setFilters(prev => ({
                                                                                ...prev,
                                                                                start_date: newStart,
                                                                                ...(suggestedEndDate && { end_date: suggestedEndDate })
                                                                            }));
                                                                        }
                                                                    }
                                                                }}
                                                                slotProps={{ textField: { size: "small", fullWidth: true } }}
                                                            />
                                                        </LocalizationProvider>
                                                    </div>
                                                    <div className="col-lg-2 col-md-3">
                                                        <label className="form-label font-size-12 text-uppercase fw-bold text-muted mb-1">End Date</label>
                                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                            <DatePicker
                                                                views={["year", "month", "day"]}
                                                                openTo="year"
                                                                format="DD-MM-YYYY"
                                                                value={filters.end_date ? dayjs(filters.end_date) : null}
                                                                onChange={(newValue) => {
                                                                    if (newValue) {
                                                                        setSelectedEndYear(newValue);
                                                                        if (!filters.end_date || dayjs(filters.end_date).year() !== newValue.year()) {
                                                                            setFilters(prev => ({ ...prev, end_date: newValue.endOf('year').format('YYYY-MM-DD') }));
                                                                        } else {
                                                                            setFilters(prev => ({ ...prev, end_date: getAdjustedEndDate(newValue, filters.start_date) }));
                                                                        }
                                                                    }
                                                                }}
                                                                slotProps={{ textField: { size: "small", fullWidth: true } }}
                                                            />
                                                        </LocalizationProvider>
                                                    </div>
                                                </>
                                            )}

                                            {filters.dateRange === 'custom' && (
                                                <>
                                                    <div className="col-md-2">
                                                        <label className="form-label text-muted small mb-1">From Date</label>
                                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                            <DatePicker
                                                                views={["year", "month", "day"]}
                                                                format="DD-MM-YYYY"
                                                                value={filters.start_date ? dayjs(filters.start_date) : null}
                                                                onChange={(newValue) => {
                                                                    const { startDate: newStart, suggestedEndDate } = getAdjustedStartDate(newValue, filters.end_date);
                                                                    setFilters(prev => ({
                                                                        ...prev,
                                                                        start_date: newStart,
                                                                        ...(suggestedEndDate && { end_date: suggestedEndDate })
                                                                    }));
                                                                }}
                                                                slotProps={{ textField: { size: "small", fullWidth: true } }}
                                                            />
                                                        </LocalizationProvider>
                                                    </div>
                                                    <div className="col-md-2">
                                                        <label className="form-label text-muted small mb-1">To Date</label>
                                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                            <DatePicker
                                                                views={["year", "month", "day"]}
                                                                format="DD-MM-YYYY"
                                                                value={filters.end_date ? dayjs(filters.end_date) : null}
                                                                onChange={(newValue) => {
                                                                    setFilters(prev => ({ ...prev, end_date: getAdjustedEndDate(newValue, filters.start_date) }));
                                                                }}
                                                                slotProps={{ textField: { size: "small", fullWidth: true } }}
                                                            />
                                                        </LocalizationProvider>
                                                    </div>
                                                </>
                                            )}


                                            <div className="col-md-2">
                                                <label className="form-label text-muted small mb-1">Ledger</label>
                                                <Select
                                                    options={ledgers}
                                                    isSearchable={true}
                                                    isClearable
                                                    placeholder="Select Ledger..."
                                                    value={
                                                        ledgers
                                                            .flatMap(group => group.options)
                                                            .find(opt => opt.value === filters.ledger_id) || null
                                                    }
                                                    onChange={(selected) =>
                                                        setFilters({ ...filters, ledger_id: selected?.value || '' })
                                                    }
                                                    className="border-primary"
                                                    styles={{
                                                        control: (base) => ({
                                                            ...base,
                                                            minHeight: '38px',
                                                        }),
                                                        groupHeading: (base) => ({
                                                            ...base,
                                                            fontWeight: 'bold',
                                                            color: '#343a40',
                                                            fontSize: '0.9rem',
                                                            paddingLeft: '4px',
                                                        }),
                                                        option: (base, state) => ({
                                                            ...base,
                                                            paddingLeft: state.data.__isGroup ? base.paddingLeft : '24px',
                                                        }),
                                                    }}
                                                />
                                            </div>

                                            <div className="col-md-2">
                                                <label className="form-label text-muted small mb-1">Project</label>
                                                <Select
                                                    options={projects}
                                                    value={projects.find(option => option.value === filters.project_id)}
                                                    onChange={(selected) => setFilters({ ...filters, project_id: selected?.value || '' })}
                                                    isClearable
                                                    placeholder="Select Project..."
                                                    className="border-primary"
                                                    styles={{
                                                        control: (base) => ({
                                                            ...base,
                                                            minHeight: '38px'
                                                        })
                                                    }}
                                                />
                                            </div>
                                            <div className="col-md-2">
                                                <label className="form-label text-muted small mb-1">Reference No</label>
                                                <input
                                                    type="text"
                                                    className="form-control border-primary"
                                                    value={filters.reference_no}
                                                    onChange={(e) => setFilters({ ...filters, reference_no: e.target.value })
                                                    }
                                                    placeholder="Enter Reference No"
                                                />
                                            </div>

                                            <div className="col-md-12 mt-3">
                                                <button
                                                    type="submit"
                                                    className="btn btn-primary me-2 px-4"
                                                    disabled={loading || (!filters.start_date && !filters.end_date && !filters.ledger_id && !filters.project_id && !filters.reference_no)}
                                                >
                                                    {loading ? (
                                                        <>
                                                            <span className="spinner-border spinner-border-sm me-1" role="status"></span>
                                                            Loading...
                                                        </>
                                                    ) : (
                                                        <>
                                                            <i className="fas fa-search me-1"></i>
                                                            Generate Report
                                                        </>
                                                    )}
                                                </button>
                                                <button
                                                    type="button"
                                                    className="btn btn-outline-secondary px-4"
                                                    onClick={handleClear}
                                                    disabled={loading}
                                                >
                                                    <i className="fas fa-eraser me-1"></i>
                                                    Clear
                                                </button>
                                            </div>
                                        </div>
                                    </form>

                                    {error && (
                                        <div className="alert alert-danger alert-dismissible fade show" role="alert">
                                            <i className="fas fa-exclamation-circle me-2"></i>
                                            {error}
                                            <button type="button" className="btn-close" onClick={() => setError(null)}></button>
                                        </div>
                                    )}

                                    {loading && !data && (
                                        <div className="text-center py-5">
                                            <div className="spinner-border text-primary" style={{ width: '3rem', height: '3rem' }} role="status">
                                                <span className="visually-hidden">Loading...</span>
                                            </div>
                                            <p className="mt-3 text-muted">Loading ledger statement data...</p>
                                        </div>
                                    )}

                                    {!loading && data && (
                                        <div className="mt-4">
                                            <div className="d-flex justify-content-between align-items-center mb-3">
                                                <div>
                                                    <h5 className="text-primary mb-1">
                                                        <i className="fas fa-file-invoice me-2"></i>
                                                        {ledgers.flatMap(group => group.options).find(l => l.value === filters.ledger_id)?.label || 'All Ledgers'}
                                                    </h5>
                                                    {filters.project_id && (
                                                        <div className="text-muted small">
                                                            Project: {projects.find(p => p.value === filters.project_id)?.label || ''}
                                                        </div>
                                                    )}
                                                </div>
                                                <div className="badge bg-light text-dark">
                                                    <i className="far fa-calendar-alt me-1"></i>
                                                    {filters.start_date && filters.end_date ? (
                                                        dayjs(filters.start_date).isSame(dayjs(filters.end_date).startOf('year'), 'day') && dayjs(filters.end_date).isSame(dayjs(filters.start_date).endOf('year'), 'day') ? (
                                                            `Jan ${dayjs(filters.start_date).format('YYYY')} - Dec ${dayjs(filters.end_date).format('YYYY')}`
                                                        ) : (
                                                            `${dayjs(filters.start_date).format('DD-MM-YYYY')} - ${dayjs(filters.end_date).format('DD-MM-YYYY')}`
                                                        )
                                                    ) : (
                                                        filters.start_date ? `From ${dayjs(filters.start_date).format('DD-MM-YYYY')}` : 
                                                        filters.end_date ? `To ${dayjs(filters.end_date).format('DD-MM-YYYY')}` : 'Beginning to Now'
                                                    )}
                                                </div>
                                            </div>

                                            {/* Summary Cards */}
                                            {/* <div className="row mb-4">
                                                <div className="col-md-3">
                                                    <div className="card bg-light border">
                                                        <div className="card-body p-3">
                                                            <h6 className="card-title text-muted small mb-1">Opening Balance</h6>
                                                            <div className={`h4 mb-0 ${data.opening_balance?.dc === 'D' ? 'text-danger' : 'text-success'}`}>
                                                                {formatBalance(data.opening_balance?.dc === 'D' ?
                                                                    safeParseFloat(data.opening_balance?.amount || 0) :
                                                                    -safeParseFloat(data.opening_balance?.amount || 0)
                                                                )}

                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <div className="card bg-light border">
                                                        <div className="card-body p-3">
                                                            <h6 className="card-title text-muted small mb-1">Total Debit</h6>
                                                            <div className="h4 mb-0 text-danger">
                                                                {safeParseFloat(data.closing_balance?.dr_total || 0).toLocaleString('en-US', { minimumFractionDigits: 2 })}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <div className="card bg-light border">
                                                        <div className="card-body p-3">
                                                            <h6 className="card-title text-muted small mb-1">Total Credit</h6>
                                                            <div className="h4 mb-0 text-success">
                                                                {safeParseFloat(data.closing_balance?.cr_total || 0).toLocaleString('en-US', { minimumFractionDigits: 2 })}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="col-md-3">
                                                    <div className="card bg-light border">
                                                        <div className="card-body p-3">
                                                            <h6 className="card-title text-muted small mb-1">Closing Balance</h6>
                                                            <div className={`h4 mb-0 ${data.closing_balance?.dc === 'D' ? 'text-danger' : 'text-success'}`}>
                                                                {formatBalance(data.closing_balance?.dc === 'D' ?
                                                                    safeParseFloat(data.closing_balance?.amount || 0) :
                                                                    -safeParseFloat(data.closing_balance?.amount || 0)
                                                                )}

                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div> */}

                                            <div className="row mb-4">
                                                {/* Opening Balance */}
                                                <div className="col-md-3">
                                                    <div className="card bg-light border">
                                                        <div className="card-body p-3">
                                                            <h6 className="card-title text-muted small mb-1">Opening Balance</h6>
                                                            <div className={`h4 mb-0 ${data.opening_balance?.dc === 'D' ? 'text-danger' : 'text-success'}`}>
                                                                {formatBalance(
                                                                    data.opening_balance?.dc === 'D'
                                                                        ? safeParseFloat(data.opening_balance?.amount || 0)
                                                                        : -safeParseFloat(data.opening_balance?.amount || 0)
                                                                )}

                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* Period Totals */}
                                                <div className="col-md-3">
                                                    <div className="card bg-light border">
                                                        <div className="card-body p-3">
                                                            <h6 className="card-title text-muted small mb-1">Total Debit (Period)</h6>
                                                            <div className="h4 mb-0 text-danger">
                                                                {safeParseFloat(data.period_totals?.dr_total || 0).toLocaleString('en-US', { minimumFractionDigits: 2 })}
                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <div className="card bg-light border">
                                                        <div className="card-body p-3">
                                                            <h6 className="card-title text-muted small mb-1">Total Credit (Period)</h6>
                                                            <div className="h4 mb-0 text-success">
                                                                {safeParseFloat(data.period_totals?.cr_total || 0).toLocaleString('en-US', { minimumFractionDigits: 2 })}
                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>

                                                {/* Closing Balance */}
                                                <div className="col-md-3">
                                                    <div className="card bg-light border">
                                                        <div className="card-body p-3">
                                                            <h6 className="card-title text-muted small mb-1">Closing Balance</h6>

                                                            {(() => {
                                                                const selectedLedgerName = ledgers.flatMap(group => group.options).find(l => l.value === filters.ledger_id)?.label;
                                                                const bank = bankAccounts.find(b => b.name?.trim().toLowerCase() === selectedLedgerName?.trim().toLowerCase());
                                                                const balanceVal = data.closing_balance?.dc === 'D'
                                                                    ? safeParseFloat(data.closing_balance?.amount || 0)
                                                                    : -safeParseFloat(data.closing_balance?.amount || 0);
                                                                const displayBalance = formatBalance(balanceVal);

                                                                if (bank) {
                                                                    const bankCurrency = (bank.base_currency?.currency || bank.currency?.currency || bank.currency || 'AED').toString().trim().toUpperCase();
                                                                    if (bankCurrency === 'USD') {
                                                                        const aedRateObj = bank.exchange_rates?.find(r =>
                                                                            (r.currency?.currency || r.currency || '').toString().trim().toUpperCase() === 'AED'
                                                                        );
                                                                        const bankRateObj = bank.exchange_rates?.find(r =>
                                                                            (r.currency?.currency || r.currency || '').toString().trim().toUpperCase() === bankCurrency
                                                                        );
                                                                        
                                                                        const globalRate = parseFloat(companySettings?.usd_to_aed || localStorage.getItem('exchange_rate') || '3.67');
                                                                        let amount = safeParseFloat(data.closing_balance?.amount || 0);
                                                                        let usdAmount = 0;

                                                                        if (aedRateObj) {
                                                                            const rate = parseFloat(aedRateObj.rate || aedRateObj.exchange_rate || 0);
                                                                            if (rate > 0) usdAmount = amount * rate;
                                                                        } else if (bankRateObj) {
                                                                            const rate = parseFloat(bankRateObj.rate || bankRateObj.exchange_rate || 0);
                                                                            if (rate > 0) usdAmount = amount / rate;
                                                                        } else if (globalRate > 0) {
                                                                            usdAmount = amount / globalRate;
                                                                        }
                                                                        return (
                                                                            <OverlayTrigger
                                                                                placement="top"
                                                                                overlay={<Tooltip id="tooltip-closing-usd">USD {usdAmount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</Tooltip>}
                                                                            >
                                                                                <div className={`h4 mb-0 ${data.closing_balance?.dc === 'D' ? 'text-danger' : 'text-success'}`} style={{ cursor: 'help' }}>
                                                                                    {displayBalance}
                                                                                </div>
                                                                            </OverlayTrigger>
                                                                        );
                                                                    }
                                                                }

                                                                return (
                                                                    <div className={`h4 mb-0 ${data.closing_balance?.dc === 'D' ? 'text-danger' : 'text-success'}`}>
                                                                        {displayBalance}
                                                                    </div>
                                                                );
                                                            })()}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>


                                            <div className="table-responsive">
                                                <table className="table table-hover align-middle">
                                                    <thead className="table-sales-gradient">
                                                        <tr>
                                                            <th style={{ width: '10%' }}>Date</th>
                                                            <th style={{ width: '12%' }}>Reference</th>
                                                            <th style={{ width: '30%' }}>Particulars</th>
                                                            <th style={{ width: '12%' }} className="text-end">Debit</th>
                                                            <th style={{ width: '12%' }} className="text-end">Credit</th>
                                                            <th style={{ width: '12%' }} className="text-end">Balance</th>
                                                            <th style={{ width: '12%' }} className="text-center">Dr/Cr</th>
                                                        </tr>
                                                    </thead>

                                                    <tbody>
                                                        {/* Opening Balance Row */}
                                                        {data.opening_balance && (
                                                            <tr className="bg-soft-light">
                                                                <td colSpan="3">
                                                                    <strong>Opening Balance</strong>
                                                                </td>
                                                                <td className="text-end">
                                                                    {data.opening_balance?.dc === 'D' ?
                                                                        formatAmount(data.opening_balance.amount) : ''
                                                                    }
                                                                </td>
                                                                <td className="text-end">
                                                                    {data.opening_balance?.dc === 'C' ?
                                                                        formatAmount(data.opening_balance.amount) : ''
                                                                    }
                                                                </td>
                                                                <td className="text-end">
                                                                    <strong className={data.opening_balance?.dc === 'D' ? 'text-danger' : 'text-success'}>
                                                                        {formatBalance(data.opening_balance?.dc === 'D' ?
                                                                            safeParseFloat(data.opening_balance?.amount || 0) :
                                                                            -safeParseFloat(data.opening_balance?.amount || 0)
                                                                        )}
                                                                    </strong>

                                                                </td>
                                                                <td className="text-center">
                                                                    <span className={`badge ${data.opening_balance?.dc === 'D' ? 'bg-danger' : 'bg-success'}`}>
                                                                        {data.opening_balance?.dc === 'D' ? 'Dr' : 'Cr'}
                                                                    </span>
                                                                </td>
                                                            </tr>
                                                        )}

                                                            {entriesWithBalance
                                                                .map((transaction, index) => {
                                                                    const ledgerEntries = transaction.items.map(item => ({
                                                                        dc: item.Entryitem.dc,
                                                                        amount: item.Entryitem.amount,
                                                                        ledgerId: item.Entryitem.ledger_id,
                                                                        ledgerName: ledgers.flatMap(g => g.options).find(l => l.value === item.Entryitem.ledger_id)?.label || 'Unknown'
                                                                    }));

                                                                    // Find the selected ledger entry side(s) to show in Dr/Cr columns
                                                                    const selectedItems = transaction.items.filter(item =>
                                                                        String(item.Entryitem.ledger_id) === String(filters.ledger_id)
                                                                    );
                                                                    
                                                                    if (selectedItems.length === 0) return null;

                                                                    const drAmount = selectedItems
                                                                        .filter(item => item.Entryitem.dc === 'D')
                                                                        .reduce((sum, item) => sum + safeParseFloat(item.Entryitem.amount), 0);
                                                                    
                                                                    const crAmount = selectedItems
                                                                        .filter(item => item.Entryitem.dc === 'C')
                                                                        .reduce((sum, item) => sum + safeParseFloat(item.Entryitem.amount), 0);


                                                                return (
                                                                    <tr key={transaction.id || index}>
                                                                        <td
                                                                            style={{ cursor: 'pointer' }}
                                                                            onClick={() => handleTransactionClick(transaction)}
                                                                        >
                                                                            {format(new Date(transaction.date), 'dd MMM yyyy')}
                                                                        </td>
                                                                        <td>
                                                                            <span
                                                                                className="badge bg-soft-primary text-primary"
                                                                                style={{ cursor: 'pointer' }}
                                                                                onClick={() => handleTransactionClick(transaction)}
                                                                            >
                                                                                {transaction.reference || '-'}
                                                                            </span>
                                                                        </td>
                                                                        <td>
                                                                            <div>
                                                                                <div className="fw-bold">{transaction.narration}</div>
                                                                                <div className="small text-muted">
                                                                                    {ledgerEntries
                                                                                        .map((entry, i) => (
                                                                                            <div key={i}>
                                                                                                <i className={`fas fa-${entry.dc === 'D' ? 'arrow-down text-danger' : 'arrow-up text-success'} me-1`}></i>
                                                                                                {entry.ledgerName}
                                                                                                <span className={`ms-2 fw-semibold ${entry.dc === 'D' ? 'text-danger' : 'text-success'}`}>
                                                                                                    ({entry.dc === 'D' ? 'Dr' : 'Cr'} {formatAmount(entry.amount)})
                                                                                                </span>
                                                                                            </div>
                                                                                        ))}
                                                                                </div>
                                                                            </div>
                                                                        </td>
                                                                        <td className="text-end text-danger fw-bold">

                                                                            {drAmount > 0 ? formatAmount(drAmount) : ''}
                                                                        </td>
                                                                        <td className="text-end text-success fw-bold">
                                                                            {crAmount > 0 ? formatAmount(crAmount) : ''}
                                                                        </td>
                                                                        <td className="text-end">
                                                                            {(() => {
                                                                                const selectedLedgerName = ledgers.flatMap(group => group.options).find(l => l.value === filters.ledger_id)?.label;
                                                                                const bank = bankAccounts.find(b => b.name?.trim().toLowerCase() === selectedLedgerName?.trim().toLowerCase());
                                                                                const balanceVal = transaction.runningBalance;
                                                                                const displayBalance = formatBalance(balanceVal);
                                                                                
                                                                                if (bank) {
                                                                                    const bankCurrency = (bank.base_currency?.currency || bank.currency?.currency || bank.currency || 'AED').toString().trim().toUpperCase();
                                                                                    if (bankCurrency === 'USD') {
                                                                                        const aedRateObj = bank.exchange_rates?.find(r =>
                                                                                            (r.currency?.currency || r.currency || '').toString().trim().toUpperCase() === 'AED'
                                                                                        );
                                                                                        const bankRateObj = bank.exchange_rates?.find(r =>
                                                                                            (r.currency?.currency || r.currency || '').toString().trim().toUpperCase() === bankCurrency
                                                                                        );
                                                                                        
                                                                                        const globalRate = parseFloat(companySettings?.usd_to_aed || localStorage.getItem('exchange_rate') || '3.67');
                                                                                        let usdAmount = 0;
                                                                                        const absAmount = Math.abs(balanceVal);
                                                                                        
                                                                                        if (aedRateObj) {
                                                                                            const rate = parseFloat(aedRateObj.rate || aedRateObj.exchange_rate || 0);
                                                                                            if (rate > 0) usdAmount = absAmount * rate;
                                                                                        } else if (bankRateObj) {
                                                                                            const rate = parseFloat(bankRateObj.rate || bankRateObj.exchange_rate || 0);
                                                                                            if (rate > 0) usdAmount = absAmount / rate;
                                                                                        } else if (globalRate > 0) {
                                                                                            usdAmount = absAmount / globalRate;
                                                                                        }
                                                                                        
                                                                                        return (
                                                                                            <OverlayTrigger
                                                                                                placement="top"
                                                                                                overlay={<Tooltip id={`tooltip-usd-${index}`}>USD {usdAmount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</Tooltip>}
                                                                                            >
                                                                                                <span className={
                                                                                                    balanceVal > 0 ? 'text-danger' :
                                                                                                        balanceVal < 0 ? 'text-success' : 'text-muted'
                                                                                                } style={{ cursor: 'help', borderBottom: '1px dotted #ccc' }}>
                                                                                                    {displayBalance}
                                                                                                </span>
                                                                                            </OverlayTrigger>
                                                                                        );
                                                                                    }
                                                                                }

                                                                                return (
                                                                                    <span className={
                                                                                        balanceVal > 0 ? 'text-danger' :
                                                                                            balanceVal < 0 ? 'text-success' : 'text-muted'
                                                                                    }>
                                                                                        {displayBalance}
                                                                                    </span>
                                                                                );
                                                                            })()}
                                                                        </td>
                                                                        <td className="text-center">
                                                                            <span className={`badge ${transaction.netLedgerAmount >= 0 ? 'bg-danger' : 'bg-success'}`}>
                                                                                {transaction.netLedgerAmount >= 0 ? 'Dr' : 'Cr'}
                                                                            </span>
                                                                        </td>
                                                                    </tr>
                                                                );
                                                            })}


                                                        {/* Closing Balance Row */}
                                                        {data.closing_balance && (
                                                            <tr className="bg-soft-light">
                                                                <td colSpan="3">
                                                                    <strong>Closing Balance</strong>
                                                                </td>
                                                                <td className="text-end">
                                                                    {data.closing_balance?.dc === 'D' ?
                                                                        formatAmount(data.closing_balance.amount) : ''
                                                                    }
                                                                </td>
                                                                <td className="text-end">
                                                                    {data.closing_balance?.dc === 'C' ?
                                                                        formatAmount(data.closing_balance.amount) : ''
                                                                    }
                                                                </td>
                                                                <td className="text-end">
                                                                    <strong className={data.closing_balance?.dc === 'D' ? 'text-danger' : 'text-success'}>
                                                                        {formatBalance(data.closing_balance?.dc === 'D' ?
                                                                            safeParseFloat(data.closing_balance?.amount || 0) :
                                                                            -safeParseFloat(data.closing_balance?.amount || 0)
                                                                        )}
                                                                    </strong>

                                                                </td>
                                                                <td className="text-center">
                                                                    <span className={`badge ${data.closing_balance?.dc === 'D' ? 'bg-danger' : 'bg-success'}`}>
                                                                        {data.closing_balance?.dc === 'D' ? 'Dr' : 'Cr'}
                                                                    </span>
                                                                </td>
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Transaction Details Offcanvas Modal */}
            <Offcanvas
                show={showModal}
                onHide={() => setShowModal(false)}
                placement="end"
                style={{ width: '600px' }}
            >
                <Offcanvas.Header closeButton className="border-bottom">
                    <Offcanvas.Title className="text-primary">
                        <i className="fas fa-receipt me-2"></i>
                        Transaction Details
                    </Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    {selectedTransaction && (
                        <div>
                            {/* Transaction Header Card */}
                            <div className="card shadow-sm mb-4 border-0 bg-light">
                                <div className="card-body">
                                    <div className="d-flex justify-content-between align-items-center mb-3">
                                        <div>
                                            <h6 className="text-muted mb-1">Transaction Date</h6>
                                            <p className="mb-0 fw-bold">{format(new Date(selectedTransaction.date), 'dd MMM yyyy')}</p>
                                        </div>
                                        <div className="text-end">
                                            <h6 className="text-muted mb-1">Reference No</h6>
                                            <span className="badge bg-primary">{selectedTransaction.reference || 'N/A'}</span>
                                        </div>
                                    </div>

                                    <div className="mt-3">
                                        <h6 className="text-muted mb-1">Narration</h6>
                                        <p className="mb-0 fw-semibold">{selectedTransaction.narration}</p>
                                    </div>
                                </div>
                            </div>

                            {/* Ledger Entries Section */}
                            <h6 className="text-muted mb-3">
                                <i className="fas fa-list me-1"></i>
                                Ledger Entries
                            </h6>

                            {selectedTransaction.items.map((item, index) => {
                                const ledgerName = ledgers.flatMap(g => g.options).find(l => l.value === item.Entryitem.ledger_id)?.label || 'Unknown';
                                const isDebit = item.Entryitem.dc === 'D';

                                return (
                                    <div key={index} className="card mb-3 border-0 shadow-sm">
                                        <div className="card-body py-3">
                                            <div className="d-flex justify-content-between align-items-center">
                                                <div>
                                                    <h6 className="mb-1 fw-semibold">{ledgerName}</h6>
                                                    <span className={`badge ${isDebit ? 'bg-danger' : 'bg-success'}`}>
                                                        {isDebit ? 'Debit' : 'Credit'}
                                                    </span>
                                                </div>
                                                <div className={`h5 mb-0 ${isDebit ? 'text-danger' : 'text-success'}`}>
                                                    {parseFloat(item.Entryitem.amount || 0).toLocaleString('en-US', { minimumFractionDigits: 2 })}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}

                            {/* Summary Section */}
                            <div className="mt-4 pt-3 border-top">
                                <h6 className="text-muted mb-3">
                                    <i className="fas fa-calculator me-1"></i>
                                    Transaction Summary
                                </h6>

                                <div className="d-flex justify-content-between align-items-center mb-2">
                                    <span className="fw-semibold">Total Debit:</span>
                                    <span className="text-danger fw-bold">
                                        {selectedTransaction.items
                                            .filter(item => item.Entryitem.dc === 'D')
                                            .reduce((sum, item) => sum + parseFloat(item.Entryitem.amount || 0), 0)
                                            .toLocaleString('en-US', { minimumFractionDigits: 2 })}
                                    </span>
                                </div>

                                <div className="d-flex justify-content-between align-items-center mb-2">
                                    <span className="fw-semibold">Total Credit:</span>
                                    <span className="text-success fw-bold">
                                        {selectedTransaction.items
                                            .filter(item => item.Entryitem.dc === 'C')
                                            .reduce((sum, item) => sum + parseFloat(item.Entryitem.amount || 0), 0)
                                            .toLocaleString('en-US', { minimumFractionDigits: 2 })}
                                    </span>
                                </div>

                                <div className="d-flex justify-content-between align-items-center mt-3 pt-2 border-top">
                                    <span className="fw-bold">Balance:</span>
                                    <span className={`fw-bold ${Math.abs(
                                        selectedTransaction.items
                                            .filter(item => item.Entryitem.dc === 'D')
                                            .reduce((sum, item) => sum + parseFloat(item.Entryitem.amount || 0), 0) -
                                        selectedTransaction.items
                                            .filter(item => item.Entryitem.dc === 'C')
                                            .reduce((sum, item) => sum + parseFloat(item.Entryitem.amount || 0), 0)
                                    ) < 0.01 ? 'text-muted' : 'text-warning'
                                        }`}>
                                        {Math.abs(
                                            selectedTransaction.items
                                                .filter(item => item.Entryitem.dc === 'D')
                                                .reduce((sum, item) => sum + parseFloat(item.Entryitem.amount || 0), 0) -
                                            selectedTransaction.items
                                                .filter(item => item.Entryitem.dc === 'C')
                                                .reduce((sum, item) => sum + parseFloat(item.Entryitem.amount || 0), 0)
                                        ).toLocaleString('en-US', { minimumFractionDigits: 2 })}
                                        {Math.abs(
                                            selectedTransaction.items
                                                .filter(item => item.Entryitem.dc === 'D')
                                                .reduce((sum, item) => sum + parseFloat(item.Entryitem.amount || 0), 0) -
                                            selectedTransaction.items
                                                .filter(item => item.Entryitem.dc === 'C')
                                                .reduce((sum, item) => sum + parseFloat(item.Entryitem.amount || 0), 0)
                                        ) < 0.01 ? ' (Balanced)' : ' (Imbalanced)'}
                                    </span>
                                </div>
                            </div>
                        </div>
                    )}
                </Offcanvas.Body>
            </Offcanvas>
        </div>
    );
};
export default LedgerStatement;
